export const STORAGE_KEYS = {
  LANGUAGE: 'i18nextLng',
} as const

export const KEY_LANGS = {
  VI: 'vi-south',
  EN: 'en',
} as const

export * from './admin-scope'
export * from './auth'
export * from './css-color-names'
export * from './date-format'
export * from './media'
export * from './pagination'
export * from './poi-categories'
export * from './poi-status'
export * from './poi-type'
export * from './status'
export * from './theme-colors'
export * from './tour-categories'
export * from './tour-transport'
export * from './translation-status'
